<!-- not-authorized.component.html -->
<div class="not-authorized-container">
    <div class="not-authorized-content">
      <h1 class="not-authorized-title">403</h1>
      <h2 class="not-authorized-subtitle">Access Denied</h2>
      <p class="not-authorized-message">
        Sorry, you don’t have permission to access this page.
      </p>
      <a href="/" class="go-home-button">Go Back to Home</a>
    </div>
  </div>
  